import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@krea/shared/design-system/accordion";
import { Button } from "@krea/shared/design-system/Button";
import { AppModal } from "@krea/shared/design-system/modal";

interface INterestRateExplanationModalProps {
  open: boolean;
  setOpen: (isOpen: boolean) => void;
}

const ACCORDION_ITEMS = [
  {
    value: "company-real-estate",
    title: "Company & Real Estate Loans",
    content: (
      <ul className="mb-0 list-disc space-y-2 pl-5">
        <li>
          <strong>Lower the interest: </strong> Decrease monthly (or yearly)
          interest rate. This is the most direct way to improve the score.
        </li>
        <li>
          <strong>Set up fee reduction: </strong> Lower the set up fee to
          improve the effective interest rate.
        </li>
        <li>
          <strong>Lower the total cost: </strong> Lowering the total cost (and
          effectively other fees included within it) will increase the
          attractiveness of the offer.
        </li>
      </ul>
    ),
  },
  {
    value: "factoring",
    title: "Factoring",
    content: (
      <ul className="mb-0 list-disc space-y-2 pl-5">
        <li>
          <strong>Lower percentages: </strong> Decrease the financing rate % or
          the credit fee %.
        </li>
        <li>
          <strong>Fee reduction: </strong> Lower the setup fee and monthly fee
          to improve attractiveness.
        </li>
        <li>
          <strong>Increase payment term days: </strong> Increasing the payment
          term days can sometimes lower the &quot;monthly&quot; effective
          interest rate, but focusing on interest rate, but focusing on the
          commission is more effective.
        </li>
      </ul>
    ),
  },
  {
    value: "leasing",
    title: "Leasing",
    content: (
      <ul className="mb-0 list-disc space-y-2 pl-5">
        <li>
          <strong>Lower monthly cost: </strong> Decrease the monthly payment.
          This is the primary driver of the leasing rate.
        </li>
        <li>
          <strong>Adjust residual value: </strong> Lowering the terminal value %
          or the down payment percentage will improve the effective interest
          rate.
        </li>
        <li>
          <strong>Set up fee reduction: </strong> Lower the set up fee to
          improve the effective interest rate.
        </li>
      </ul>
    ),
  },
  {
    value: "revolving-credit",
    title: "Revolving Credit",
    content: (
      <ul className="mb-0 list-disc space-y-2 pl-5">
        <li>
          <strong>Interest rate reduction: </strong> Focus primarily on lowering
          the interest rate.
        </li>
        <li>
          <strong>Limit fee reduction: </strong> Decrease the limit fee per
          year. Because revolving credit has no fixed end date, annual fees
          heavily impact the heavily impact the effective monthly interest rate.
        </li>
        <li>
          <strong>Set up fee reduction: </strong> Lower the set up fee to
          improve improve the effective interest rate.
        </li>
      </ul>
    ),
  },
];

const InterestRateExplanationModal = ({
  open,
  setOpen,
}: INterestRateExplanationModalProps) => {
  const onCloseModal = () => {
    setOpen(false);
  };

  return (
    <AppModal
      open={open}
      setOpen={setOpen}
      onClose={onCloseModal}
      title="Improving the Effective interest rate"
      footer={
        <Button variant="secondary" onClick={onCloseModal}>
          Close
        </Button>
      }
    >
      <Accordion type="multiple" className="mt-0 flex flex-col gap-3">
        {ACCORDION_ITEMS.map((item) => (
          <AccordionItem
            key={item.value}
            value={item.value}
            className="relative rounded-xl border pl-3 pr-2"
          >
            <AccordionTrigger className="">{item.title}</AccordionTrigger>
            <AccordionContent>{item.content}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </AppModal>
  );
};

export { InterestRateExplanationModal };
